<template>
    <div class="price-box main">
        <div class="items flex-bt">
            <div class="child">
                <div class="title none">精选电商计划</div>
                <div class="old-price none"></div>
                <div class="price none">HK$ {{ fee[0] }}<span>/月</span></div>
                <div class="buy none">立即购买</div>
            </div>
            <div class="child">
                <div class="title ">精选电商计划</div>
                <div class="old-price "></div>
                <div class="price ">HK$498 <span>/月</span></div>
                <div class="buy ">立即购买</div>
            </div>
            <div class="child">
                <div class="title">专业电商计划</div>
                <div class="old-price"></div>
                <div class="price">HK$1288 <span>/月</span></div>
                <div class="buy">立即购买</div>
            </div>
            <div class="child">
                <div class="title">全方位电商计划</div>
                <div class="old-price"></div>
                <div class="price">HK$1888 <span>/月</span></div>
                <div class="buy">立即购买</div>
            </div>
        </div>
        <div class="items big-title flex-bt">
            可购式影片
        </div>
        <div class="items flex-bt">
            <div class="child active">
                自建可购式短片
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                自建可购式直播
                <div class="tips flex-start">
                    <img class="tips-icon" src="@/assets/images/tips.png" alt="">
                    <div class="info">每额外6000分钟为HK$120</div>
                </div>
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                超正影片主导网店主页
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items big-title flex-bt">
            网店功能
        </div>
        <div class="items flex-bt">
            <div class="child">
                注册用户
            </div>
            <div class="child text-center">
                上限1个
            </div>
            <div class="child text-center">
                上限5个
            </div>
            <div class="child text-center">
                上限8个
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                全港首创KOL配对爆单引擎
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child ">
                自动化物流智能系统
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>

        <div class="items flex-bt">
            <div class="child ">
                自建产品商城
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child ">
                自订网域
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child ">
                免费LOOPSHOP网域
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child ">
                可自行设计主页
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                超易手机一键直播
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                独家执货专员系统
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                手机及电脑管理网店
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                简易推广优惠设定(产品捆绑)
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                超强数据分析
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                轻松同步直播至社交平台 (Facebook, Youtube)
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child flex-start">
                收款方式
                <div class="tips flex-start">
                    <img class="tips-icon" src="@/assets/images/tips.png" alt="">
                    <div class="info">每项交易会抽取 2.9%手续费</div>
                </div>
            </div>
            <div class="child pay-icon">
                <img class="icon-items" src="@/assets/images/pay-icon-1.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-2.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-3.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-4.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-5.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-6.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-7.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-8.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-9.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-10.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-11.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-12.png" alt="">
            </div>
        </div>

        <div class="items big-title flex-bt">
            更多强大功能即将登场
        </div>
        <div class="items flex-bt">
            <div class="child active">
                全港首创KOL分销秘密工具
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                轻松同步直播至社交平台 (Facebook, Youtube)
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                极速AI图片编辑神制
            </div>
            <div class="child text-center">
                上限20张相
            </div>
            <div class="child text-center">
                上限50张相
            </div>
            <div class="child text-center">
                上限80张相
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                智能仓库发货系统
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                会员积分系统
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                独家导出直播留言
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                员工权限设置
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        fee: {
            type: Array,
            default: () => []
        }
    },
}
</script>
<style lang="scss" scoped>
.price-box {
    border: 1px solid rgba(204, 204, 204, 1);
    margin-top: 0.32rem;

    .items {
        border-bottom: 1px solid rgba(204, 204, 204, 1);
        align-items: stretch;

        &.big-title {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 400;
            font-size: 0.24rem;
            line-height: 0.34rem;
            color: #000000;
            padding: 0.12rem 0.32rem;
            background: rgba(214, 246, 246, 1);
        }


        &:last-child {
            border: none;
        }

        .child {
            flex: 1;
            border-right: 1px solid rgba(204, 204, 204, 1);
            padding: 0.32rem;
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 400;
            font-size: 0.16rem;
            line-height: 0.30rem;
            position: relative;
            word-break: break-all;

            &.text-center {
                text-align: center;
            }

            &.pay-icon {
                width: 55%;
                flex: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;

                .icon-items {
                    width: 0.74rem;
                    height: 0.42rem;
                    margin: 6px;
                    display: block;
                }
            }


            .tips {
                position: relative;

                &:hover {
                    .info {
                        display: block;
                    }
                }

                .tips-icon {
                    width: 0.2rem;
                    height: 0.2rem;
                    margin-left: 0.06rem;
                    display: block;
                }

                .info {
                    display: none;
                    position: absolute;
                    width: 2.2rem;
                    left: 0.4rem;
                    top: -50%;
                    padding: 0.08rem;
                    background: #0BD9D5;
                    border-radius: 0.08rem;
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.16rem;
                    line-height: 0.22rem;
                    color: #000000;
                    z-index: 99;
                }
            }

            .icon {
                width: 0.2rem;
                height: 0.2rem;
                display: block;
                margin: auto;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            &.active {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 0.2rem;
                line-height: 0.28rem;
                color: #E02E43;
                display: flex;
                justify-content: flex-start;
            }

            /* Black/100 */

            color: #000000;


            &:last-child {
                border: none;
            }

            .none {
                opacity: 0;
            }

            .title {
                padding-top: 0.3rem;
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 0.24rem;
                line-height: 0.34rem;
                color: #000000;
            }

            .old-price {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.24rem;
                color: #808080;
                margin: 0.27rem 0 0.18rem 0;
                height: 0.24rem;
                text-decoration: line-through
            }

            .price {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 0.32rem;
                line-height: 0.32rem;
                color: #000000;

                span {
                    font-size: 0.18rem;
                }
            }

            .buy {
                width: 100%;
                height: 0.64rem;
                border: 1px solid #E02E43;
                color: #E02E43;
                border-radius: 0.08rem;
                margin: 0 auto;
                margin-top: 0.18rem;
                text-align: center;
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 0.24rem;
                line-height: 0.64rem;
                cursor: pointer;
            }
        }
    }
}

@media (max-width: 750px) {
    .price-box {
        padding: 0;
    }

    .price-box .items .child .price {
        font-size: 0.28rem;
        line-height: 0.28rem;
    }

    .price-box .items .child.pay-icon {
        width: 59%;
    }

    .price-box .items .child {
        word-break: break-all;
    }
}
</style>